<script>
import { mapState } from 'vuex';
import MineInput from './mineInput.vue';
export default {
    name: "Header",
    data() {
        return {
            isShowMenu: false,
            searchStr: '',
            isShowSearch: false,
            isHide: false,
        };
    },
    computed: {
        ...mapState(["menu", "isLogin", "userinfo"]),
    },
    components: {
        MineInput
        
    },
    mounted() {
        this.$store.dispatch('getNav');
        window.addEventListener('click', this.hideAllList);
        window.addEventListener('mousemove', this.mouseMove);
    },
    destroyed() {},
    watch: {
        "$route": function(){
            this.hideAllList();
            this.isShowMenu = false;
            if(this.$route.path == '/'){
                this.isHide = true;
            }else{
                this.isHide = false;
            }
        }
    },
    methods: {
  	    //鼠标移动事件
        mouseMove() {
            // 首页
            if(this.$route.path == '/'){
                this.isHide = false;
            }
        },
        showList(index){
            if(this.menu[index].isChecked){
                this.menu[index].isChecked = false;
            }else{
                this.hideAllList();
                this.menu[index].isChecked = true;
            }
        },
        hideAllList(){
            this.isShowSearch = false;
            this.menu.forEach(item => {
                item.isChecked = false;
            });
        },
        showSearch(){
            if(this.isShowSearch){
                this.isShowSearch = false;
            }else{
                this.hideAllList();
                this.isShowMenu = false;
                this.isShowSearch = true;
                // this.$refs.search.focus();
            }
        },
        search(){
            this.$router.push(`/products?search=${this.searchStr}`);
            this.searchStr = '';
        },
    },
};
</script>

<template>
    <div class="header" :class="{is_home: $route.path == '/', hide: isHide}">
        <div class="header_item">
            <div class="menu left" :class="{show: isShowMenu}">
                <div class="btn_close" @click="isShowMenu = false"></div>
                <div class="item" v-for="(item, index) in menu" :key="index" :class="{active: item.isChecked}">
                    <div class="link" v-if="item.list.length > 0" @click.stop="showList(index)">{{item.name}}</div>
                    <router-link class="link" :to="`/products?id=${item.id}`" v-else>{{item.name}}</router-link>
                    <div class="list">
                        <div class="_item" v-for="(_item, _index) in item.list" :key="_index">
                            <router-link :to="`/products?id=${_item.id}&parentId=${item.id}`">{{_item.name}}</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="menu_switch" @click="isShowMenu = true"><span></span><span></span><span></span></div>
        </div>
        <div class="logo" v-if="$route.path != '/'">
            <router-link to="/"></router-link>
        </div>
        <div class="header_item">
            <div class="menu right">
                <div class="item">
                    <div class="link" @click.stop="showSearch">
                        <div class="icon_wrap">
                            <img class="icon black" src="@/assets/images/icon_search2.png" alt=""/>
                            <img class="icon white" src="@/assets/images/icon_search3.png" alt=""/>
                        </div>
                        <span>SEARCH</span>
                    </div>
                </div>
                <div class="item" v-if="!isLogin">
                    <router-link class="link" to="/login">
                        <div class="icon_wrap">
                            <img class="icon black" src="@/assets/images/icon_login2.png" alt=""/>
                            <img class="icon white" src="@/assets/images/icon_login3.png" alt=""/>
                        </div>
                        <span>LOG IN</span>
                    </router-link>
                </div>
                <div class="item" v-else>
                    <router-link class="link" to="/mine">
                        <div class="icon_wrap">
                            <img class="icon black" src="@/assets/images/icon_login2.png" alt=""/>
                            <img class="icon white" src="@/assets/images/icon_login3.png" alt=""/>
                        </div>
                        <span>{{userinfo.first_name}} {{userinfo.last_name}}</span>
                    </router-link>
                </div>
                <div class="item">
                    <router-link class="link" to="/cart">
                        <div class="icon_wrap">
                            <img class="icon black" src="@/assets/images/icon_shopping2.png" alt=""/>
                            <img class="icon white" src="@/assets/images/icon_shopping3.png" alt=""/>
                        </div>
                        <span>SHOPPING BAG</span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="search_popup" :class="{active: isShowSearch}" @click.stop>
            <input type="text" placeholder="search.." ref="search" v-model="searchStr" @keyup.enter="search"/>
            <div class="btn_close" @click="isShowSearch = false"></div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.header{
    position: fixed;
    width: 100%;
    height: 110px;
    top: 0;
    left: 0;
    background: #fff;
    display: flex;
    // align-items: center;
    padding: 0 4%;
    z-index: 9;
    user-select: none;
    // font-weight: bold;
    &.is_home{
        color: #fff;
        background: none;
        .menu{
            .item{
                &.active{
                    .link{
                        border-color: #fff;
                    }
                }
                .link{
                    &::after{
                        border-color: #fff;
                    }
                    .icon_wrap{
                        .icon{
                            &.black{
                                opacity: 0;
                            }
                            &.white{
                                opacity: 1;
                            }
                        }
                    }
                }
                .list{
                    background: none;
                }
            }
        }
        &:hover{
            color: #000;
            background: #fff;
            @media screen and (max-width: 768px) {
                background: none;
            }
            .menu{
                .item{
                    &.active{
                        .link{
                            border-color: #000;
                        }
                    }
                    .link{
                        &::after{
                            border-color: #000;
                        }
                        .icon_wrap{
                            .icon{
                                &.black{
                                    opacity: 1;
                                }
                                &.white{
                                    opacity: 0;
                                }
                            }
                        }
                    }
                    .list{
                        background: #fff;
                    }
                }
            }
        }
        @media screen and (max-width: 768px) {
            .menu{
                .item{
                    .link{
                        .icon_wrap{
                            .icon{
                                &.black{
                                    opacity: 1;
                                }
                                &.white{
                                    opacity: 0;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    &.hide{
        opacity: 0;
        visibility: hidden;
        @media screen and (max-width: 768px) {
            opacity: 1;
            visibility: visible;
        }
    }
    .logo{
        display: flex;
        align-items: center;
        a{
            display: block;
            width: 91px;
            height: 33px;
            background: url('~@/assets/images/logo.svg') no-repeat 0/100%;
        }
    }
    .header_item{
        flex: 1;
    }
    .menu{
        height: 100%;
        display: flex;
        &:last-child{
            justify-content: flex-end;
        }
        &.right{
            .item{
                .link{
                    &::after{
                        display: none;
                    }
                }
                &:last-child{
                    margin-right: 0;
                }
            }
        }
        .item{
            font-size: 12px;
            margin-right: 30px;
            position: relative;
            display: flex;
            align-items: center;
            &.active{
                .link{
                    border-bottom-color: #777;
                }
                .list{
                    opacity: 1;
                    visibility: visible;
                }
            }
            .link{
                display: flex;
                align-items: center;
                border-bottom: 1px solid transparent;
                cursor: pointer;
                line-height: 2;
                &:hover{
                    border-bottom-color: #777;
                }
                .icon_wrap{
                    position: relative;
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                    .icon{
                        margin-right: 0;
                        position: absolute;
                        top: 0;
                        left: 0;
                        &.white{
                            opacity: 0;
                        }
                    }
                }
                .icon{
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }
                &::after{
                    margin-left: 6px;
                    content: "";
                    display: block;
                    width: 5px;
                    height: 5px;
                    border-top: 1px solid #000;
                    border-right: 1px solid #000;
                    transform: rotate(45deg) translate(-50%, 50%);
                }
            }
            a.link{
                &::after{
                    display: none;
                }
            }
            .list{
                opacity: 0;
                visibility: hidden;
                // transition: all .3s;
                position: absolute;
                // background: rgba($color: #fff, $alpha: .7);
                background: #fff;
                // color: #777;
                // color: #000;
                padding: 0 10000px 20px;
                left: -10000px;
                top: 80%;
                ._item{
                    margin-bottom: 15px;
                    white-space: nowrap;
                    &:last-child{
                        margin-bottom: 0;
                    }
                    a{
                        border-bottom: 1px solid transparent;
                        &:hover{
                            color: #000;
                            border-bottom-color: #777;
                        }
                    }
                }
            }
        }
        .btn_close{
            display: none;
        }
    }
    .menu_switch{
        display: none;
    }
    .search_popup{
        position: absolute;
        background: rgba($color: #fff, $alpha: .7);
        top: 100%;
        left: 0;
        width: 100%;
        padding: 20px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        opacity: 0;
        visibility: hidden;
        transition: all .3s;
        &.active{
            opacity: 1;
            visibility: visible;
        }
        input{
            appearance: none;
            outline: none;
            border: none;
            border-radius: 0;
            background: #fff;
            margin: 0;
            padding: 0;
            width: 214px;
            font-size: 12px;
            border-bottom: 1px solid #000;
            height: 30px;
            padding: 0 12px;
            margin-bottom: 40px;
            font-family: 'bpg_glaho';
        }
        .btn_close{
            width: 16px;
            height: 16px;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            &::before,
            &::after{
                content: "";
                width: 30px;
                border-bottom: 2px solid #000;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
    }
    @media screen and (max-width: 768px) {
        height: 1.2rem;
        padding: 0;
        .search_popup{
            padding: .4rem 0;
            input{
                width: 4rem;
                font-size: .24rem;
                height: .6rem;
                padding: 0 .24rem;
                margin-bottom: .4rem;
            }
            .btn_close{
                width: .32rem;
                height: .32rem;
            }
        }
        .menu_switch{
            display: block;
            width: 1.2rem;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            span{
                display: block;
                width: .35rem;
                border-top: .02rem solid #000;
                margin: .04rem 0;
            }
        }
        .menu{
            &.left{
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba($color: #fff, $alpha: .9);
                z-index: 1;
                display: block;
                opacity: 0;
                transform: translate(-100%, 0);
                transition: all .3s;
                &.show{
                    opacity: 1;
                    transform: translate(0, 0);
                }
                .btn_close{
                    display: block;
                    width: 1.2rem;
                    height: 1.2rem;
                    position: relative;
                    &::before,
                    &::after{
                        content: "";
                        width: .35rem;
                        border-top: .02rem solid #000;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%) rotate(45deg);
                    }
                    &::after{
                        transform: translate(-50%, -50%) rotate(-45deg);
                    }
                }
                .item{
                    padding: 0 .34rem;
                    display: block;
                    margin-right: 0;
                    &.active{
                        .link{
                            &::after{
                                transform: translate(-50%, 50%) rotate(135deg);
                            }
                        }
                        .list{
                            display: block;
                        }
                    }
                    .link{
                        justify-content: space-between;
                        border-bottom: 1px solid #cccccc;
                        height: 1rem;
                        font-size: .24rem;
                        padding: 0 .15rem 0 .4rem;
                        &::after{
                            display: block;
                            width: .1rem;
                            height: .1rem;
                        }
                        .icon_wrap{
                            width: .4rem;
                            height: .4rem;
                        }
                        .icon{
                            width: .4rem;
                            height: .4rem;
                            margin-right: 0;
                        }
                    }
                    .list{
                        display: none;
                        position: relative;
                        opacity: 1;
                        visibility: visible;
                        padding: 0;
                        left: 0;
                        top: 0;
                        background: none;
                        font-size: .22rem;
                        padding: .25rem 0 0 .6rem;
                        ._item{
                            margin-bottom: 0;
                            a{
                                display: block;
                                height: .7rem;
                                line-height: .7rem;
                                border-bottom: none;
                                &::before{
                                    content: "·";
                                    font-weight: bold;
                                    margin-right: .1rem;
                                }
                            }
                        }
                    }
                }
            }
            &.right{
                .item{
                    margin-right: .3rem;
                    .link{
                        border-bottom: none;
                        span{
                            display: none;
                        }
                    }
                }
            }
        }
        .logo{
            a{
                width: .76rem;
                height: .27rem;
            }
        }
    }
}
</style>